// extracted by mini-css-extract-plugin
export var actionButton = "_p6-0";
export var actionMenuContainer = "_p6-i";
export var bubble = "_p6-2";
export var bubbleActionMenu = "_p6-j";
export var bubbleContext = "_p6-6";
export var bubbleItems = "_p6-7";
export var customer = "_p6-3";
export var divider = "_p6-8";
export var fileList = "_p6-9";
export var hiddenComment = "_p6-o";
export var infoAbove = "_p6-a";
export var internal = "_p6-4";
export var lightActionButton = "_p6-1";
export var link = "_p6-b";
export var merchant = "_p6-5";
export var message = "_p6-c";
export var profilePicture = "_p6-e";
export var quillToolbarContainer = "_p6-f";
export var senderDate = "_p6-g";
export var senderDateCustomer = "_p6-h";
export var senderName = "_p6-d";
export var time = "_p6-k";
export var uploadedImage = "_p6-l";
export var username = "_p6-m";
export var xsmall = "_p6-n";